import type { FreelancerForgotPasswordLocales } from '../types';

const freelancerForgotPasswordLocales: FreelancerForgotPasswordLocales = {
  haveYouForgottenYourPassword:
    'Ben je je wachtwoord vergeten? Vul het emailadres van je account hier in om je wachtwoord te resetten.',
  resetPassword: 'Wachtwoord Resetten',
  title: 'Wachtwoord vergeten',
};

export default freelancerForgotPasswordLocales;
